import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';
import { FileSearchColumnFields, FileSearchGridOptionsFormatter } from '@app/search/gridOptions/file-search-grid-options-formatter';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { HttpClient } from '@angular/common/http';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { RadLinkRendererComponent } from '@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component';
import { StatusToDisplayName } from '@app/core/utilities/pipes/status-to-display-name.pipe';

export class FileChooserGridOptionsFormatter extends FileSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public http: HttpClient,
    public statusToDisplayName: StatusToDisplayName
  ) {
    super(resourceDictionaryService, bsshDatePipe, http, statusToDisplayName);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<FileSearchColumnFields> {
    const inclusiveColumns: FileSearchColumnFields[] = [
      FileSearchColumnFields.Name,
      FileSearchColumnFields.Path,
      FileSearchColumnFields.FileType,
      FileSearchColumnFields.Dataset,
      FileSearchColumnFields.Project,
      FileSearchColumnFields.Analysis,
      FileSearchColumnFields.Size,
      FileSearchColumnFields.Created,
      FileSearchColumnFields.DatasetStatus,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<FileSearchColumnFields>[] = [
      {
        colId: FileSearchColumnFields.Name,
        cellRendererFramework: RadLinkRendererComponent,
        showAlways: true,
        cellRendererParams: (params) => {
          if(params.data && 
            params.data.DatasetFile && 
            params.data.DatasetFile.ParentDataset && 
            params.data.DatasetFile.ParentDataset.AppSession
          ) {
            const resource: any = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType);
            const tooltipText = !this.isRowSelectable(params.node) ? this.getUnselectableRowMessage(params.node) : null;
            const cellRendererParams = DataTableUtilities.getRadLinkParams(
                resource.Name,
                BsApiEndPoints.getDatasetFileRoute(resource),
                tooltipText,
                null,
                60
            );

            return cellRendererParams;
          } else {
            return {};
          }
        },
      }
  ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}